export default "__VITE_ASSET__BKTaHEPz__"